import { ref } from 'vue'

/** In-flight REST calls that should light the menu spinner. */
export const httpPending = ref(0)

/**
 * Counts one request until it settles. Quiet polls stay out of this.
 */
export function trackHttp<T>(work: Promise<T>): Promise<T> {
  httpPending.value += 1
  return work.finally(() => {
    httpPending.value = Math.max(0, httpPending.value - 1)
  })
}
